module.exports = __webpack_public_path__ + "img/project-13.b81cadae.png";